import React from "react";
import { useTranslation } from "react-i18next";

export function DashboardHeader() {
  const { t } = useTranslation();
  return (
    <>
      <h1 className="text-4xl font-bold mb-2">{t("dashboard")}</h1>
      <p className="text-xl text-muted-foreground mb-8">{t("track_progress")}</p>
    </>
  );
}
